import styled from 'styled-components';

import {
  blackSphera,
  greenSp,
  grayLightSphera,
  graySphera,
  whiteSphera,
  yellowSphera
} from 'src/utilities/UIStyles/variables/Colors';

export const HomeContainer = styled.section``;

export const Main = styled.main`
  background-image: url('https://finsphera-resources.s3.amazonaws.com/applicantHomeMain.jpg');
  background-size: cover;
  background-position: right;
  padding-top: 15%;
  padding-bottom: 15%;

  > h2 {
    color: ${whiteSphera};
    font-size: 4vw;
    text-align: center;

    > span {
      color: ${yellowSphera};
    }
  }

  > p {
    color: ${whiteSphera};
    font-size: 2vw;
    text-align: center;
    width: 70%;
    margin: 2.5% auto 0 auto;
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > h2 {
      > span {
      }
    }

    > p {
    }
  }

  @media (max-width: 600px) {
    padding-top: 25%;
    padding-bottom: 10%;

    > h2 {
      font-size: 10vw;

      > span {
      }
    }

    > p {
      font-size: 5vw;
      width: 95%;
    }
  }
`;

export const InvestUs = styled.section`
  padding-top: 5%;
  padding-bottom: 5%;

  > div:nth-child(1) {
    > h2 {
      color: ${blackSphera};
      font-size: 3vw;
      text-align: center;
    }
  }

  > div:nth-child(1) {
    display: flex;
    width: 90%;
    margin: 5% auto 1% auto;

    > div {
      width: 33%;
      /* background-color: pink; */

      > figure {
        align-self: center;
        width: 150px;
        height: 150px;
        margin: 0 auto 2.5% auto;
        /* background-color: orange; */

        img {
        }
      }

      > h3 {
        color: ${blackSphera};
        text-align: center;
        font-size: 1.5vw;
      }

      > p {
        color: ${graySphera};
        text-align: center;
        font-size: 1.3vw;
        width: 85%;
        margin: 2.5% auto 0 auto;
      }
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div:nth-child(1) {
      > div {
        > figure {
          width: 120px;
          height: 120px;
          margin: 0 auto 5% auto;

          img {
          }
        }

        > h3 {
        }

        > p {
        }
      }
    }
  }

  @media (max-width: 600px) {
    padding-top: 5%;
    > div:nth-child(1) {
      flex-direction: column;
      margin: 5% auto 1% auto;

      > div {
        width: 100%;

        > figure {
          width: 110px;
          height: 110px;
          margin: 5% auto 2.5% auto;

          img {
          }
        }

        > h3 {
          font-size: 4.5vw;
        }

        > p {
          font-size: 4vw;
          margin: 2.5% auto 2.5% auto;
        }
      }
    }
  }
`;

export const OurServices = styled.section`
  > div:nth-child(1) {
    display: flex;

    > div {
      width: 50%;
      background-color: ${blackSphera};
      padding: 4% 5% 2.5% 5%;

      > h2 {
        color: ${whiteSphera};
        font-size: 3vw;
        width: 80%;
        margin-bottom: 5%;
      }

      > ul {
        margin-left: 2.5%;

        > li {
          color: ${whiteSphera};
          font-size: 1.2vw;
          margin-bottom: 1%;
        }
      }
    }

    > figure {
      width: 50%;

      > img {
        width: 100%;
        height: 100%;
      }
    }
  }

  > div:nth-child(2) {
    display: flex;
    flex-direction: row-reverse;

    > div {
      width: 50%;
      background-color: ${greenSp};
      padding: 5% 5% 2.5% 5%;

      > h2 {
        color: ${blackSphera};
        font-size: 3vw;
        width: 90%;
        margin-bottom: 5%;
      }

      > ul {
        > li {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          color: ${blackSphera};
          font-size: 1.2vw;
          margin-bottom: 1%;

          > p {
            margin-right: 2.5%;

            > span {
              color: ${blackSphera};
              font-weight: bold;
            }
          }

          > figure {
            width: 20px;
            height: 20px;
            cursor: pointer;

            > img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }

    > figure {
      width: 50%;

      > img {
        width: 100%;
        height: 100%;
      }
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div:nth-child(1) {
      > div {
        > h2 {
        }

        > ul {
          > li {
          }
        }
      }

      > figure {
        > img {
        }
      }
    }

    > div:nth-child(2) {
      > div {
        > h2 {
        }

        > ul {
          > li {
            > p {
              > span {
              }
            }

            > figure {
              > img {
              }
            }
          }
        }
      }

      > figure {
        > img {
        }
      }
    }
  }

  @media (max-width: 600px) {
    > div:nth-child(1) {
      flex-direction: column;

      > div {
        width: 100%;

        > h2 {
          font-size: 7vw;
          width: 90%;
        }

        > ul {
          margin-left: 5%;

          > li {
            font-size: 4.2vw;
          }
        }
      }

      > figure {
        width: 100%;

        > img {
        }
      }
    }

    > div:nth-child(2) {
      display: flex;
      flex-direction: column;

      > div {
        width: 100%;

        > h2 {
          font-size: 7vw;
          width: 100%;
        }

        > ul {
          padding-bottom: 5%;

          > li {
            font-size: 4.2vw;

            > p {
              margin-right: 2.5%;

              > span {
              }
            }

            > figure {
              > img {
              }
            }
          }
        }
      }

      > figure {
        width: 100%;

        > img {
        }
      }
    }
  }
`;

export const StartRequest = styled.div`
  padding-top: 5%;
  padding-bottom: 5%;

  > div:nth-child(1) {
    display: flex;
    width: 90%;
    margin: 0 auto 1% auto;

    > div {
      width: 25%;

      > figure {
        text-align: center;
        width: 150px;
        height: 150px;
        margin: 0 auto 2.5% auto;

        img {
          /* width: 100%;
         height: 100%; */
        }
      }

      > h3 {
        color: ${graySphera};
        text-align: center;
        font-size: 1.5vw;
      }

      > p {
        color: ${graySphera};
        text-align: center;
        font-size: 1.3vw;
        width: 85%;
        margin: 2.5% auto 0 auto;
      }
    }
  }

  > div:nth-child(2) {
    > a {
      display: block;
      color: ${whiteSphera};
      font-size: 1.5vw;
      font-weight: bold;
      text-decoration: none;
      text-align: center;
      line-height: 60px;
      width: 20%;
      height: 60px;
      margin: 5% auto 0 auto;
      border-radius: 5px;
      background-color: ${blackSphera};
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div:nth-child(1) {
      > div {
        > figure {
          width: 120px;
          height: 120px;
          margin: 0 auto 5% auto;

          img {
          }
        }

        > h3 {
        }

        > p {
        }
      }
    }
  }

  > div:nth-child(2) {
    > a {
    }
  }

  @media (max-width: 600px) {
    padding-top: 5%;

    > div:nth-child(1) {
      flex-direction: column;
      margin: 5% auto 1% auto;

      > div {
        width: 100%;

        > figure {
          width: 110px;
          height: 110px;
          margin: 5% auto 2.5% auto;

          img {
          }
        }

        > h3 {
          font-size: 4.5vw;
        }

        > p {
          font-size: 4vw;
          margin: 2.5% auto 2.5% auto;
        }
      }
    }

    > div:nth-child(2) {
      > a {
        font-size: 4.5vw;
        line-height: 60px;
        width: 100%;
        height: 60px;
      }
    }
  }
`;

export const Sponsors = styled.section`
  background: ${greenSp};
  height: 200px;

  > div {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 90%;
    height: 100%;
    margin: auto;

    > figure:nth-child(1) {
      width: 300px;

      img {
        width: 100%;
        height: 100%;
        filter: grayscale(1);
      }
    }

    > figure:nth-child(2) {
      width: 110px;

      img {
        width: 100%;
        height: 100%;
        filter: grayscale(1);
      }
    }

    > figure:nth-child(3) {
      width: 250px;

      img {
        width: 100%;
        height: 100%;
        filter: grayscale(1);
      }
    }

    > figure:nth-child(4) {
      width: 250px;

      img {
        width: 100%;
        height: 100%;
        filter: grayscale(1);
      }
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    height: 150px;

    > div {
      > figure:nth-child(1) {
        width: 60px;

        img {
        }
      }

      > figure:nth-child(2) {
        width: 100px;

        img {
        }
      }

      > figure:nth-child(3) {
        width: 40px;

        img {
        }
      }

      > figure:nth-child(4) {
        width: 100px;

        img {
        }
      }
    }
  }
`;

export const Transformation = styled.section`
  padding-bottom: 5%;

  > h2 {
    color: ${graySphera};
    font-size: 3vw;
    text-align: center;
    width: 40%;
    margin: 5% auto 5% auto;

    > span {
      color: ${greenSp};
      font-size: 3vw;
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > h2 {
      > span {
      }
    }
  }

  @media (max-width: 600px) {
    > h2 {
      font-size: 5vw;
      width: 90%;
      margin: 10% auto;

      > span {
        font-size: 5vw;
      }
    }
  }
`;

export const CardContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 70%;
  margin: auto;

  @media (min-width: 600px) and (max-width: 1024px) {
    width: 80%;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    width: 90%;
  }
`;

export const Card = styled.div`
  padding: 4% 5%;
  width: 40%;
  -webkit-box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
  box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);

  > div:nth-child(1) {
    display: flex;
    justify-content: space-between;

    > div {
      margin-bottom: 5%;

      > figure {
        width: 50px;
        height: 45px;
        margin-bottom: 40%;

        img {
          width: 100%;
          height: 100%;
        }
      }

      > h3 {
        color: ${graySphera};
        font-size: 1.5vw;
      }

      > p {
        color: ${graySphera};
        font-size: 1.2vw;
      }
    }

    > figure {
      width: 140px;
      height: 140px;

      > img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
  }

  > div:nth-child(2) {
    > p {
      font-size: 1.1vw;
      color: ${grayLightSphera};
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div:nth-child(1) {
      > div {
        > figure {
          img {
          }
        }

        > h3 {
        }

        > p {
        }
      }

      > figure {
        > img {
        }
      }
    }

    > div:nth-child(2) {
      > p {
      }
    }
  }

  @media (max-width: 600px) {
    width: 100%;
    margin-bottom: 10%;

    > div:nth-child(1) {
      > div {
        > figure {
          width: 40px;
          height: 35px;

          img {
          }
        }

        > h3 {
          font-size: 4.5vw;
        }

        > p {
          font-size: 4.2vw;
        }
      }

      > figure {
        width: 140px;
        height: 140px;

        > img {
        }
      }
    }

    > div:nth-child(2) {
      > p {
        font-size: 4.1vw;
      }
    }
  }
`;

export const CarouselControllers = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 12%;
  margin: 2.5% auto 0 auto;

  > figure:nth-child(1) {
    width: 25px;
    height: 35px;
    cursor: pointer;
    transition: all 0.5s;

    &:hover {
      transform: scale(1.1);
    }

    img {
      width: 100%;
      height: 100%;
    }
  }

  > p:nth-child(2) {
    color: ${grayLightSphera};
    font-size: 1.3vw;
  }

  > figure:nth-child(3) {
    width: 25px;
    height: 35px;
    cursor: pointer;
    transition: all 0.5s;

    &:hover {
      transform: scale(1.1);
    }

    > img {
      width: 100%;
      height: 100%;
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > figure:nth-child(1) {
      &:hover {
      }

      img {
      }
    }

    > p:nth-child(2) {
    }

    > figure:nth-child(3) {
      &:hover {
      }

      > img {
      }
    }
  }

  @media (max-width: 600px) {
    width: 40%;

    > figure:nth-child(1) {
      &:hover {
      }

      img {
      }
    }

    > p:nth-child(2) {
      font-size: 4.3vw;
    }

    > figure:nth-child(3) {
      &:hover {
      }

      > img {
      }
    }
  }
`;
